import type { FC } from "react"
import { Outlet } from "react-router"
import { TenantSettingsNav } from "@/components/tenant/tenant-settings-nav"

export const TenantSettingsLayout: FC = () => {
  return (
    <div className="mx-auto flex w-full max-w-[832px] flex-col gap-5 lg:-mt-6 lg:min-h-[711px] lg:flex-row lg:gap-0">
      <TenantSettingsNav ariaLabel="設定" />

      <div className="min-w-0 w-full px-4 py-5 lg:w-[656px] lg:pb-[60px]">
        <Outlet />
      </div>
    </div>
  )
}
